<template>
  <div>
    <v-autocomplete
      :value="value"
      @input="$emit('input', $event)"
      :items="pages"
      item-text="title"
      item-value="id"
      :multiple="false"
      outlined
      rounded
      :placeholder="settings.title"
      class="tag-selector page-select"
      clearable
      hide-details="auto"
      :rules="rules"
    >
      <template v-slot:item="{ item }">
        <div class="page-select__item">
          <div class="page-select__item-title">{{ item.title }}</div>
          <div class="page-select__item-url" :title="formatUrl(item.url)">
            {{ formatUrl(item.url) }}
          </div>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    settings: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    links: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pages: [],
    };
  },
  created() {
    this.fetchPages();
  },
  methods: {
    async fetchPages() {
      const { data } = await this.$api.Page.lite();
      this.pages = data;
    },
    formatUrl(url) {
      if (!url) return "";
      return url.startsWith("/") ? url : `/${url}`;
    },
  },
};
</script>

<style scoped lang="scss">
.page-select__item {
  width: 100%;
  overflow: hidden;
  padding: 4px 0;
}

.page-select__item-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page-select__item-url {
  font-size: 12px;
  color: #8a8a8e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
